import { render, staticRenderFns } from "./chatBlock.vue?vue&type=template&id=15b44fc8&"
import script from "./chatBlock.vue?vue&type=script&lang=js&"
export * from "./chatBlock.vue?vue&type=script&lang=js&"
import style0 from "./chatBlock.vue?vue&type=style&index=0&id=15b44fc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports